import React from 'react';

export const useListener = (element: any, onClick: () => void) => {
    React.useEffect(() => {
        if (!element) return;
        const handleClick = () => {
            onClick();
        };
        
        element.addEventListener('click', handleClick);

        return () => {
            element.removeEventListener('click', handleClick);
        };
    }, [element]);
};
